import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { useSession } from "../../../_runtime/iam/session.context";
import { Navigate } from "react-router-dom";

/**
 * Functional Component: HomeScreen
 * 
 * This component serves as the landing page of the application. It redirects users based on their authentication status:
 * - Authenticated users are redirected to a role-specific route.
 * - Unauthenticated users are redirected to the login page.
 * 
 * Returns:
 * @returns {JSX.Element} A JSX element that performs redirection based on user authentication.
 */
const HomeScreen: React.FC<any> = () => {
  const {getRouteBasedOnRole} = useSession();
  return (
    <>
      <AuthenticatedTemplate>
        <Navigate to={getRouteBasedOnRole()} />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Navigate to="/auth/login" />
      </UnauthenticatedTemplate>
    </>
  );
};

export default HomeScreen;
